import { n, t as a } from "./custom-element-wb8eOGrn.js";
var c = (t, e) => {
  const s = new CustomEvent("get-tab-state", {
    bubbles: !0,
    detail: {
      group: e,
      state: {}
    }
  });
  return t.dispatchEvent(s), s.detail.state ?? {};
}, o = class extends a {
  constructor() {
    super();
  }
  connectedCallback() {
    this.state.add("selectedTab", this.dataset.defaultTab ?? null), this.addEventListener("tab-change", (t) => {
      const { group: e, value: s, lastFocus: i } = t.detail;
      if (e === this.dataset.tabGroup)
        if (t.stopPropagation(), s === "next") {
          const r = this.querySelector(`tab-panel[data-tab-group="${this.dataset.tabGroup}"][aria-current=step]+tab-panel`);
          r ? this.state.selectedTab.set(r.dataset.item) : i && this.closest("section")?.querySelector(i)?.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
        } else this.state.selectedTab.set(s);
    }), this.addEventListener("get-tab-state", (t) => {
      t.detail.group === this.dataset.tabGroup && (t.stopPropagation(), t.detail.state = this.state);
    });
  }
}, u = class extends a {
  get name() {
    return this.dataset.item ?? "";
  }
  constructor() {
    super();
  }
  connectedCallback() {
    const { selectedTab: t } = c(this, this.dataset.tabGroup ?? ""), e = this.name;
    this.effects.push(n(() => {
      e === t.get() ? this.setAttribute("aria-current", "step") : this.removeAttribute("aria-current");
    }));
  }
}, l = class extends a {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener("click", () => {
      this.dispatchEvent(new CustomEvent("tab-change", {
        bubbles: !0,
        detail: {
          group: this.dataset.tabGroup,
          value: this.dataset.item,
          lastFocus: this.dataset.lastFocus
        }
      }));
    }), this.hasAttribute("aria-current") && this.dispatchEvent(new CustomEvent("tab-change", {
      bubbles: !0,
      detail: {
        group: this.dataset.tabGroup,
        value: this.dataset.item,
        lastFocus: this.dataset.lastFocus
      }
    }));
    const { selectedTab: t } = c(this, this.dataset.tabGroup), e = this.dataset.item;
    this.effects.push(n(() => {
      e === t.get() ? this.setAttribute("aria-current", "step") : this.removeAttribute("aria-current");
    }));
  }
};
customElements.define("tab-list", o);
customElements.define("tab-item", l);
customElements.define("tab-panel", u);
export {
  c as getTabState
};
